import PageMainTitle from './PageMainTitle'

export default PageMainTitle
